import { usePermissions } from "@/hooks/useUnifiedAuth";
import { PERMISSIONS } from "@/constants/permissions";

export interface OnDemandRequestPermissions {
  /** Solicitar coleta PREVISTA em contrato — o fluxo com pré-seleção de demanda. */
  canRequestScheduled: boolean;
  /** Solicitar coleta NÃO prevista em contrato — o "Continuar sem pré-seleção". */
  canRequestExtra: boolean;
  /** Pode abrir o wizard por algum dos dois caminhos. */
  canRequestAny: boolean;
}

/**
 * As duas permissões de criação de solicitação sob demanda, num lugar só —
 * GR-637.
 *
 * O wizard e o botão que leva até ele precisam concordar: oferecer a entrada
 * para quem não pode concluir nenhum dos dois caminhos é levar a pessoa a uma
 * tela sem saída.
 *
 * A assimetria entre as duas é proposital:
 *
 * - `scheduled` é ACESSO BASE (grupo `default`, obrigatório) — usa
 *   `hasBaselinePermission` para não derrubar quem a migração ainda não
 *   alcançou (GR-561, regra 16).
 * - `extra` é ACESSO ADITIVO (grupo `add-on-request`) — usa `hasPermission`,
 *   sem a escapatória do não migrado, como manda o contrato de
 *   `useUnifiedAuth`. Perdoar ali alargaria acesso em vez de proteger.
 */
export function useOnDemandRequestPermissions(): OnDemandRequestPermissions {
  const { hasBaselinePermission, hasPermission } = usePermissions();

  const canRequestScheduled = hasBaselinePermission(
    PERMISSIONS.REQUEST_ON_DEMAND_COLLECT_SCHEDULED,
  );
  const canRequestExtra = hasPermission(
    PERMISSIONS.REQUEST_ON_DEMAND_COLLECT_EXTRA,
  );

  return {
    canRequestScheduled,
    canRequestExtra,
    canRequestAny: canRequestScheduled || canRequestExtra,
  };
}
